// src/components/IntroBox.tsx
import React from 'react';
import {
  SBox,
  SDivider,
  STitle,
  Sitem,
  SuBox,
} from '../../components/Dashboard/AdminPanel/styles';
import Texts from '../../components/Texts';
import MenuBox from 'components/Dashboard/AdminPanel/MenuBox';
import { Box } from '@mui/material';

interface AdminPanelProps {
  mode?: string;
}

const AdminPanel: React.FC<AdminPanelProps> = () => {
  return (
    // Was 450px, which capped the card regardless of what SBox or MenuBox
    // asked for. SBox itself now sets the 620px limit.
    <Box
      sx={{
        width: '100%',
        maxWidth: '620px',
        margin: '0 auto',
        padding: '32px',
      }}
    >
      <SBox>
        <STitle>{Texts.AdminPanel.title}</STitle>
        {/* <SsubTitle>{Texts.intro.subTitle}</SsubTitle> */}
        <Sitem>{Texts.AdminPanel.subTitle}</Sitem>
        <SuBox>
          <MenuBox />
        </SuBox>
      </SBox>
    </Box>
  );
};

export default AdminPanel;
